import { useDebouncedValue } from '@/hooks/useDebouncedValue'
import { tenantsApi } from '@/services/api/tenant/tenantsEnhanced'
import { useTenantSearchFormContext } from './useTenantSearchFormContext'

export const useSearchTenants = (page?: number, size?: number) => {
  const { values } = useTenantSearchFormContext()
  const { name } = useDebouncedValue(values, 100)

  return tenantsApi.endpoints.listTenants.useQuery({ query: name.trim(), page, size })
}
